<template>
  <div class="rate-wrap">
    <div
      class="box-wrap"
      v-for="(item,index) in ratedData"
      :key="index"
    >
      <div class="title">评价飞手</div>
      <div class="name">
        <div class="imgs">
          <van-image :src="item.avatar"></van-image>
        </div>
        <div class="names">{{item.nickname}}</div>
        <div class="title">匿名评价</div>
      </div>
      <div class="rate-box">
        <van-rate
          v-model="item.stars"
          readonly
          color="#FF9922"
          :size="30"
          class="rates"
        />
        <div class="titles">"{{getStars(item.stars)}}"</div>
      </div>
      <div class="upload-box">
        <div class="title">{{item.content}}</div>
        <div
          class="loadimg-box"
          v-if="item.image"
        >
          <van-image
            :src="item.image"
            @click="prievImg(item.image)"
          ></van-image>
        </div>
      </div>
    </div>

  </div>
</template>
<script>
import axios from "../../http";
import { mapState } from "vuex";
import { ImagePreview } from "vant";
export default {
  name: "rated",
  components: {},
  props: {},
  data() {
    return {
      order_sn: this.$route.query.order_sn,
      ratedData: []
    };
  },
  computed: {
    ...mapState(["token"])
  },
  watch: {},
  mounted() {
    this.getRated();
  },
  destroyed() {},
  methods: {
    prievImg(img) {
      ImagePreview([img]);
    },
    getRated() {
      axios
        .fetchPost("/api/order/detail", {
          token: this.token,
          order_sn: this.order_sn
        })
        .then(res => {
          let data = res.data;
          if (data.code == 200) {
            this.ratedData = data.data.groups;
          }
        })
        .catch(error => {
          console.log("error :", error);
        });
    },
    getStars(number) {
      let text = "";
      switch (number) {
        case 1:
          text = "非常差";
          break;
        case 2:
          text = "较差";
          break;
        case 3:
          text = "一般";
          break;
        case 4:
          text = "较好";
          break;
        case 5:
          text = "非常好";
          break;
      }
      return text;
    }
  }
};
</script>
<style lang="stylus" scoped>
.rate-wrap
  padding-top 10px
  .box-wrap
    width 95%
    padding-top 10px
    margin 0 auto
    background #ffffff
    font-family Microsoft YaHei
    text-align left
    margin-bottom 10px
    & > .title
      color #282828
      font-size 15px
      line-height 1.2
      margin 15px
      font-weight 400
    .name
      display flex
      align-items center
      margin-bottom 20px
      line-height 1.2
      .imgs
        width 40px
        height 40px
        background #55CC99
        border-radius 50%
        overflow hidden
        margin-right 15px
        margin-left 15px
      .names
        flex 1
      & > .title
        color #989898
        font-size 12px
        margin-right 10px
    .rate-box
      display flex
      margin-bottom 20px
      .rates
        flex 1
        margin-left 20px
      & > .titles
        font-size 15px
        margin-right 12px
    .upload-box
      border-top 1px solid #e5e5e5
      padding-top 15px
      padding-left 15px
      padding-bottom 15px
      & > .title
        color #282828
        font-size 15px
        margin-bottom 15px
      .loadimg-box
        width 70px
        min-height 70px
        // border 1px solid #e5e5e5
  .submit
    width 66%
    height 40px
    text-align center
    line-height 40px
    background rgba(85, 204, 153, 1)
    border-radius 40px
    font-size 17px
    font-family Microsoft YaHei
    font-weight 400
    color rgba(255, 255, 255, 1)
    margin 20px auto
</style>